export default __webpack_public_path__ + "static/media/bg-audit-e-reputation.c0e713bc.webp";